module.exports = __webpack_public_path__ + "img/qq.78ed91cb.png";